var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer"},[_c('b-container',{staticClass:"d-flex flex-column align-items-center py-5"},[_c('h2',{staticClass:"title"},[_vm._v("CONTACT")]),_c('Contact')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }